import {useState} from 'react'
import useApi from '../../../services/useApi'

function useGetOrderAuditOprations() {
  const Api = useApi()
  const [isOperationLoading, setIsOperationLoading] = useState(false)

  async function onUpdateStatus(orderId: number | string, payload: any) {
    return Api.patch(`/orders/price-audit/report/${orderId}`, payload, {
      setLoading: setIsOperationLoading,
      refetch: 'order-audit-list',
      successMessage: payload.is_archived
        ? 'Order archived successfully'
        : 'Order unarchived successfully',
    })
  }

  return {
    onUpdateStatus,
    isOperationLoading,
  }
}

export default useGetOrderAuditOprations
